import { render } from "./AlertsMenu.vue?vue&type=template&id=41295a7d"
import script from "./AlertsMenu.vue?vue&type=script&lang=js"
export * from "./AlertsMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__